import React, { useState, useEffect, Fragment } from 'react';
import { Item, Product, Engine, Loading, NoResults } from '../components';
import queryString from 'query-string';
import Pagination from "react-js-pagination";
import { useHistory, useLocation } from "react-router-dom";
import { CommonService, TrackingService } from '../services';
import { isLoggedUser, getLoggedUserId, getLoggedUserToken } from "../redux/selectors";
import { connect } from "react-redux";
import { setAuthorizationHeader } from '../utils/UserAPI';
import { UserService } from '../services';
import { logoutUser } from '../redux/actions';
import SearchFilter from '../components/SearchFilter';

const Search = ({ loggedUser, logoutUser, loggedUserId, userToken }) => {
    const history = useHistory();
    const location = useLocation();
    const itemsPerPage = 10
    const parsed = queryString.parse(window.location.search);
    const [query, setQuery] = useState(parsed.q);
    const [items, setItems] = useState([]);
    const [page, setPage] = useState(history.location.state !== undefined ? history.location.state.page : 1);
    const [totalItemsCount, setTotalItemsCount] = useState(1);
    const [loading, setLoading] = useState(false);
    const [onlyProducts, setOnlyProducts] = useState(false);
    const [onlyEngines, setOnlyEngines] = useState(false);
    const [UserInfo, setUserInfo] = useState(null);
    const [SearchFilterSummary, setSearchFilterSummary] = useState(null);
    const [SearchFilters, setSearchFilters] = useState(null);
    const [SearchFiltersOn, setSearchFiltersOn] = useState(false);
    const [AvailableOnline, setAvailableOnline] = useState(false);

    useEffect(() => {
        if (loggedUser)
        {
            setAuthorizationHeader(userToken);

            if (UserInfo==null)
            {
                console.log("userInfo.get: ", userToken);
                UserService.getUserInfo().then(user => {
                    console.log("userInfo.get.response: ", user.data);
                    if (user.status == 200)
                    {
                        if (user.data.results && user.data.results.Message &&
                            user.data.results.Message.search("not authorized")>0)
                            {
                                handleLogout();
                            }
                        setUserInfo(user.data.data);

                    }
                });
            
            }
        }
        else
        {
            setUserInfo(0);
        }

    }, [userToken]);

    const handleLogout = () => {
        logoutUser();
        history.push("/");
    }

    const handleCategoryFilter = (filteredItems) => {
        console.log("search.handleCategoryFilter:", filteredItems);

        setSearchFilters(filteredItems);
        setSearchFiltersOn(true);
    }

    const parseSearchFilters = (filters, element) => {
        console.log("search.parseSearchFilters:", filters);

        let _items = SearchFilters.filter(item => typeof item.id === "string" && item.id.startsWith(element))
                .map(item => item.id.replace(element, ""))
                .join(",");

        if (_items.length>0)
            return _items;
        else
            return null;
    }

    useEffect(() => {
        if (SearchFilters)
        {
            let availableOnline = parseSearchFilters(SearchFilters, "ao_");
            let cat1Items = parseSearchFilters(SearchFilters, "cat1_");
            let cat2Items = parseSearchFilters(SearchFilters, "cat2_");

            if(availableOnline==0)
                setAvailableOnline(true);
            else 
                setAvailableOnline(false);

            console.log("search.SearchFilters.availableOnline:", availableOnline);

            if (cat1Items || cat2Items || availableOnline==0 || SearchFiltersOn)
            {
                getItems();
                setPage(1);
            }
        }
    }, [SearchFilters]);



    useEffect(() => {
        const parsed = queryString.parse(window.location.search);
        console.log("search.qa.parsed:", parsed);

        if (parsed?.available==1)
            setAvailableOnline(true);
        
        setQuery(parsed.q);

        if (parsed.q != query) {
            setPage(1);
        }
    }, [location.search])

    useEffect(() => {
        setLoading(true);
        setOnlyProducts(false);
        setOnlyEngines(false);

        if (UserInfo!=null)
        {
            getItems();
            window.scrollTo(0, 0);
        }
    }, [page, query, UserInfo])

    const goToPage = (page) => {
        setPage(page);
        history.replace({
            pathname:  "/search",
            search: window.location.search,
            state: {
                page: page
            } 
        });
    }

    async function getItems() {
        console.log("search.getItems:");
        //console.log("search.getItems.loggedUserId:", loggedUserId);
        let _availableOnline=false;

        let cat1Items = parseSearchFilters(SearchFilters, "cat1_");
        let cat2Items = parseSearchFilters(SearchFilters, "cat2_");
        let availableOnline = parseSearchFilters(SearchFilters, "ao_");

        if (availableOnline==0)
            _availableOnline=true;

        console.log("search.getItems.cat1Items:", cat1Items);

        let _custId = -1;
        if (UserInfo != null && UserInfo !=0)
            _custId = UserInfo?.PartnerHdrCustId;

        CommonService.getSimpleSearch(query, itemsPerPage, page, _custId, _availableOnline, cat1Items, cat2Items)
            .then(function(response) {
                if (response.status === 200) {
                    setLoading(false);
                    const data = response.data.SearchResults;
                    const summary = response.data.SearchFilterSummary

                    
                    console.log("search.getItems.getSimpleSearch.res.cat1Items:", cat1Items);

                    if (cat1Items==null && cat2Items==null)
                        setSearchFilterSummary(summary);

                    console.log("search.getItems.getSimpleSearch.response:", response);

                    const engines = data.filter(item => item.engineId !== "");
                    const products = data.filter(item => item.saleItem !== "");
                    if (engines.length === 0 && products.length > 0) {
                        setOnlyProducts(true);
                    }
                    if (products.length === 0 && engines.length > 0) {
                        setOnlyEngines(true);
                    }
                    setItems(data);
                    setTotalItemsCount(1);

                    let _itemCount = summary?.totalRows==undefined?0:summary?.totalRows;
                    setTotalItemsCount(_itemCount);

                    console.log("search.getItems.getSimpleSearch.res.totalRows:", _itemCount);
                    
                    if (page==1)
                        TrackingService.saveSearch(loggedUserId, query, _itemCount)
                }
            }).catch(function(error) {
                console.log(error);
            });
    }
    
    return (
        <div className="search-results">
            <div className="container">
                <div className="row">
                    <div className="col-md-10 offset-md-1">
                        <div className="row">
                            <div className="col-sm-12">
                                {query!="myitems" ? <h6>Results for: {query}</h6> : null}
                                <SearchFilter data={SearchFilterSummary} categoryFilter={handleCategoryFilter} availableOnline={AvailableOnline}></SearchFilter>
                                {loading ? <Loading /> : 
                                    <Fragment>
                                        {items.length > 0 ? 
                                            <Fragment>
                                            <div className="results">
                                                {onlyProducts ?
                                                    items.map((item, index) =>
                                                        <Product
                                                            key={index}
                                                            productId={item.itemRow}
                                                            saleItem={item.saleItem}
                                                            oeNumber={item.oeNumber}
                                                            categoryChild={item.categoryChild}
                                                            categoryParent={item.categoryParent}
                                                            description={item.description}
                                                            imagePath={item.imagePath}
                                                            listPrice={loggedUser == true ? item.listPrice : null}
                                                        />
                                                    )
                                                : null}
                                                {onlyEngines ?
                                                    items.map((item, index) =>
                                                        <Engine
                                                            key={index}
                                                            engineId={item.engineId}
                                                            brandName={item.brandName}
                                                            horsePower={item.horsePower}
                                                            stroke={item.stroke}
                                                            cylinders={item.cylinders}
                                                            modelNumber={item.modelNumber}
                                                            startYear={item.startYear}
                                                            stopYear={item.stopYear}
                                                        />
                                                    )
                                                : null}
                                                {onlyEngines === false && onlyProducts === false ?
                                                    items.map((item, index) =>
                                                        <Item
                                                            key={index}
                                                            productId={item.itemRow}
                                                            engineId={item.engineId}
                                                            saleItem={item.item}
                                                            categoryChild={item.categoryChild}
                                                            categoryParent={item.categoryParent}
                                                            description={item.description}
                                                            brandName={item.brandName}
                                                            horsePower={item.horsePower}
                                                            modelNumber={item.modelNumber}
                                                            startYear={item.startYear}
                                                            stopYear={item.stopYear}
                                                            imagePath={item.imagePath}
                                                            listPrice={loggedUser == true ? item.listPrice : null}
                                                        />
                                                    )
                                                : null}
                                            </div>
                                            {totalItemsCount > itemsPerPage ? (
                                            <div className="text-center mt-2">
                                                <Pagination
                                                    itemClass="page-item"
                                                    linkClass="page-link"
                                                    activePage={page}
                                                    itemsCountPerPage={itemsPerPage}
                                                    totalItemsCount={totalItemsCount}
                                                    pageRangeDisplayed={5}
                                                    onChange={goToPage}
                                                />
                                            </div>
                                            ) : null}
                                            </Fragment>
                                        : <NoResults />
                                        }
                                    </Fragment>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = store => {
    const loggedUser = isLoggedUser(store);
    const loggedUserId = getLoggedUserId(store);
    const userToken = getLoggedUserToken(store);
    return { loggedUser, loggedUserId, userToken };
}
//export default connect(mapStateToProps)(Search);
export default connect(mapStateToProps, { logoutUser })(Search);